import { Outlet,  useNavigate, useOutletContext } from "react-router-dom"
import { useEffect } from "react"
import { useComputed, useSignal } from "@preact/signals-react"

export default function Profile() {

    const navigate = useNavigate()
    const { user, config, accessToken, userPermissions, userPermissionsSummary, accordionData: sidebarAccordionData  } = useOutletContext()

    useEffect(() => {
        if (userPermissionsSummary.value && !userPermissionsSummary.value.canViewProfiles) {
            addNotification('You are not authorized to view UTG profiles for this account.', NotificationTypes.ERROR, true)
            navigate(`/`)
        }
    }, [userPermissionsSummary.value])
        
    const canEditSignal = useComputed(() => {
        return userPermissionsSummary?.value?.canEditProfiles
    })

    return (
        <>
        <Outlet context={{ config, accessToken, user, userPermissions, userPermissionsSummary, canEditSignal, sidebarAccordionData }} />
        </>
    )

}